import { render, staticRenderFns } from "./JoinVerification.vue?vue&type=template&id=50a66e20&lang=pug&"
import script from "./JoinVerification.vue?vue&type=script&lang=js&"
export * from "./JoinVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JoinVerification.vue"
export default component.exports